module.exports = __webpack_public_path__ + "12e452f716425f908c918deb56f4af81.png";